import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16e28c86"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    name: "crypto-plan-card",
    class: "plan-card"
};
const _hoisted_2 = { class: "crypto-is" };
const _hoisted_3 = {
    key: 0,
    class: "crypto-is"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    key: 1,
    class: "crypto-is"
};
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
import { useMessage } from '@/const/messages';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        cryptoName: null,
        term: null,
        maxInterestRate: null,
        minInterestRate: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { STAKING_LIST_CONTENT, PLANCARD, format } = useMessage();
        const FREE_PLAN = 1;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CryptoIcon, {
                    class: "crypto_icon",
                    base: props.cryptoName,
                    width: 50
                }, null, 8, ["base"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(props.minInterestRate) + " " + _toDisplayString(props.minInterestRate !== props.maxInterestRate ? ' ~ ' + props.maxInterestRate : '') + "% ", 1),
                (props.term === FREE_PLAN)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_LIST_CONTENT).FREE)) + " ", 1),
                        (_unref(store).state.isSmartPhone)
                            ? (_openBlock(), _createElementBlock("br", _hoisted_4))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_LIST_CONTENT).PLAN)), 1)
                    ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.term + _unref(format)(_unref(PLANCARD).DAY)), 1))
            ]));
        };
    }
});
